import { Component } from '@angular/core';
import { TopBarCustomerComponent } from '@shared/components/top-bar/top-bar-customer/top-bar-customer.component';
import { UserProfileMenuComponent } from '@modules/user/components/user-profile-menu/user-profile-menu.component';

@Component({
    selector: 'app-top-bar-actions',
    imports: [TopBarCustomerComponent, UserProfileMenuComponent],
    template: `
        <section [style.height.px]="40" class="top-bar-actions flex flex-row gap-2 align-items-center justify-content-end">
            <app-top-bar-customer></app-top-bar-customer>
            <app-user-profile-menu></app-user-profile-menu>
        </section>
    `
})
export class TopBarActionsComponent {}
